module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_balloon-a159aa457dad67e02973693d5b505fde.png";